export const LINEAR_PROGRESS_BAR_CATEGORY_KEY = 'base' as const;
export const LINEAR_PROGRESS_BAR_COMPONENT_KEY = 'linearProgressBar' as const;
